import CustomSlider from "./custom-slider";

class ImagesAndSliders {
  
  sliders: NodeListOf<HTMLElement>;

  constructor() {
    this.sliders = document.querySelectorAll('.images-and-sliders__slider');
    this.initSliders();
  }
  
  initSliders() {
    this.sliders.forEach((slider) => {
      new CustomSlider(slider, {
        endless: true,
      });
    });
  }

}

export default function imagesAndSliders() {
  return new ImagesAndSliders();
}